// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/type_common.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type {
  GenEnum,
  GenFile,
  GenMessage,
} from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Timestamp, TimestampJson } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';

/**
 * Describes the file proto/v1/type_common.proto.
 */
export const file_proto_v1_type_common: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_google_protobuf_timestamp],
  );

/**
 * @generated from message vmspdb.api.proto.v1.Pagination
 */
export type Pagination = Message<'vmspdb.api.proto.v1.Pagination'> & {
  /**
   * @generated from field: int64 total = 1;
   */
  total: bigint;

  /**
   * @generated from field: string next_token = 2;
   */
  nextToken: string;

  /**
   * @generated from field: string previous_token = 3;
   */
  previousToken: string;

  /**
   * @generated from field: uint32 page = 4;
   */
  page: number;

  /**
   * @generated from field: uint32 limit = 5;
   */
  limit: number;
};

/**
 * @generated from message vmspdb.api.proto.v1.Pagination
 */
export type PaginationJson = {
  /**
   * @generated from field: int64 total = 1;
   */
  total?: string;

  /**
   * @generated from field: string next_token = 2;
   */
  nextToken?: string;

  /**
   * @generated from field: string previous_token = 3;
   */
  previousToken?: string;

  /**
   * @generated from field: uint32 page = 4;
   */
  page?: number;

  /**
   * @generated from field: uint32 limit = 5;
   */
  limit?: number;
};

export type PaginationValid = Pagination;

/**
 * Describes the message vmspdb.api.proto.v1.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema: GenMessage<
  Pagination,
  { jsonType: PaginationJson; validType: PaginationValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_type_common, 0);

/**
 * @generated from message vmspdb.api.proto.v1.Address
 */
export type Address = Message<'vmspdb.api.proto.v1.Address'> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string;

  /**
   * @generated from field: string city = 2;
   */
  city: string;

  /**
   * @generated from field: string state = 3;
   */
  state: string;

  /**
   * @generated from field: string zip = 4;
   */
  zip: string;

  /**
   * @generated from field: string tax_location = 5;
   */
  taxLocation: string;

  /**
   * @generated from field: string county = 6;
   */
  county: string;

  /**
   * Extended information transformed from Google maps
   *
   * @generated from field: vmspdb.api.proto.v1.AddressComponents components = 7;
   */
  components?: AddressComponents;
};

/**
 * @generated from message vmspdb.api.proto.v1.Address
 */
export type AddressJson = {
  /**
   * @generated from field: string address = 1;
   */
  address?: string;

  /**
   * @generated from field: string city = 2;
   */
  city?: string;

  /**
   * @generated from field: string state = 3;
   */
  state?: string;

  /**
   * @generated from field: string zip = 4;
   */
  zip?: string;

  /**
   * @generated from field: string tax_location = 5;
   */
  taxLocation?: string;

  /**
   * @generated from field: string county = 6;
   */
  county?: string;

  /**
   * Extended information transformed from Google maps
   *
   * @generated from field: vmspdb.api.proto.v1.AddressComponents components = 7;
   */
  components?: AddressComponentsJson;
};

export type AddressValid = Address;

/**
 * Describes the message vmspdb.api.proto.v1.Address.
 * Use `create(AddressSchema)` to create a new message.
 */
export const AddressSchema: GenMessage<
  Address,
  { jsonType: AddressJson; validType: AddressValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_type_common, 1);

/**
 * @generated from message vmspdb.api.proto.v1.LocationSearch
 */
export type LocationSearch = Message<'vmspdb.api.proto.v1.LocationSearch'> & {
  /**
   * @generated from field: double lat = 1;
   */
  lat: number;

  /**
   * @generated from field: double lng = 2;
   */
  lng: number;

  /**
   * @generated from field: double radius_in_miles = 3;
   */
  radiusInMiles: number;
};

/**
 * @generated from message vmspdb.api.proto.v1.LocationSearch
 */
export type LocationSearchJson = {
  /**
   * @generated from field: double lat = 1;
   */
  lat?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: double lng = 2;
   */
  lng?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: double radius_in_miles = 3;
   */
  radiusInMiles?: number | 'NaN' | 'Infinity' | '-Infinity';
};

export type LocationSearchValid = LocationSearch;

/**
 * Describes the message vmspdb.api.proto.v1.LocationSearch.
 * Use `create(LocationSearchSchema)` to create a new message.
 */
export const LocationSearchSchema: GenMessage<
  LocationSearch,
  { jsonType: LocationSearchJson; validType: LocationSearchValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_type_common, 2);

/**
 * @generated from message vmspdb.api.proto.v1.AddressComponent
 */
export type AddressComponent =
  Message<'vmspdb.api.proto.v1.AddressComponent'> & {
    /**
     * @generated from field: string long_name = 1;
     */
    longName: string;

    /**
     * @generated from field: string short_name = 2;
     */
    shortName: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.AddressComponent
 */
export type AddressComponentJson = {
  /**
   * @generated from field: string long_name = 1;
   */
  longName?: string;

  /**
   * @generated from field: string short_name = 2;
   */
  shortName?: string;
};

export type AddressComponentValid = AddressComponent;

/**
 * Describes the message vmspdb.api.proto.v1.AddressComponent.
 * Use `create(AddressComponentSchema)` to create a new message.
 */
export const AddressComponentSchema: GenMessage<
  AddressComponent,
  { jsonType: AddressComponentJson; validType: AddressComponentValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_type_common, 3);

/**
 * @generated from message vmspdb.api.proto.v1.AddressComponents
 */
export type AddressComponents =
  Message<'vmspdb.api.proto.v1.AddressComponents'> & {
    /**
     * @generated from field: double lat = 1;
     */
    lat: number;

    /**
     * @generated from field: double lng = 2;
     */
    lng: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.AddressComponent street_number = 3;
     */
    streetNumber?: AddressComponent;

    /**
     * aka street name
     *
     * @generated from field: vmspdb.api.proto.v1.AddressComponent route = 4;
     */
    route?: AddressComponent;

    /**
     * city
     *
     * @generated from field: vmspdb.api.proto.v1.AddressComponent locality = 5;
     */
    locality?: AddressComponent;

    /**
     * state
     *
     * @generated from field: vmspdb.api.proto.v1.AddressComponent administrative_area_level_1 = 6;
     */
    administrativeAreaLevel1?: AddressComponent;

    /**
     * county
     *
     * @generated from field: vmspdb.api.proto.v1.AddressComponent administrative_area_level_2 = 7;
     */
    administrativeAreaLevel2?: AddressComponent;

    /**
     * township
     *
     * @generated from field: vmspdb.api.proto.v1.AddressComponent administrative_area_level_3 = 8;
     */
    administrativeAreaLevel3?: AddressComponent;

    /**
     * @generated from field: vmspdb.api.proto.v1.AddressComponent country = 9;
     */
    country?: AddressComponent;

    /**
     * @generated from field: vmspdb.api.proto.v1.AddressComponent postal_code = 10;
     */
    postalCode?: AddressComponent;

    /**
     * @generated from field: vmspdb.api.proto.v1.AddressComponent postal_code_suffix = 11;
     */
    postalCodeSuffix?: AddressComponent;

    /**
     * @generated from field: vmspdb.api.proto.v1.AddressComponent neighborhood = 12;
     */
    neighborhood?: AddressComponent;

    /**
     * @generated from field: string place_id = 22;
     */
    placeId: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.AddressComponents
 */
export type AddressComponentsJson = {
  /**
   * @generated from field: double lat = 1;
   */
  lat?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: double lng = 2;
   */
  lng?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: vmspdb.api.proto.v1.AddressComponent street_number = 3;
   */
  streetNumber?: AddressComponentJson;

  /**
   * aka street name
   *
   * @generated from field: vmspdb.api.proto.v1.AddressComponent route = 4;
   */
  route?: AddressComponentJson;

  /**
   * city
   *
   * @generated from field: vmspdb.api.proto.v1.AddressComponent locality = 5;
   */
  locality?: AddressComponentJson;

  /**
   * state
   *
   * @generated from field: vmspdb.api.proto.v1.AddressComponent administrative_area_level_1 = 6;
   */
  administrativeAreaLevel1?: AddressComponentJson;

  /**
   * county
   *
   * @generated from field: vmspdb.api.proto.v1.AddressComponent administrative_area_level_2 = 7;
   */
  administrativeAreaLevel2?: AddressComponentJson;

  /**
   * township
   *
   * @generated from field: vmspdb.api.proto.v1.AddressComponent administrative_area_level_3 = 8;
   */
  administrativeAreaLevel3?: AddressComponentJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AddressComponent country = 9;
   */
  country?: AddressComponentJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AddressComponent postal_code = 10;
   */
  postalCode?: AddressComponentJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AddressComponent postal_code_suffix = 11;
   */
  postalCodeSuffix?: AddressComponentJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AddressComponent neighborhood = 12;
   */
  neighborhood?: AddressComponentJson;

  /**
   * @generated from field: string place_id = 22;
   */
  placeId?: string;
};

export type AddressComponentsValid = AddressComponents;

/**
 * Describes the message vmspdb.api.proto.v1.AddressComponents.
 * Use `create(AddressComponentsSchema)` to create a new message.
 */
export const AddressComponentsSchema: GenMessage<
  AddressComponents,
  { jsonType: AddressComponentsJson; validType: AddressComponentsValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_type_common, 4);

/**
 * @generated from message vmspdb.api.proto.v1.UploadedFile
 */
export type UploadedFile = Message<'vmspdb.api.proto.v1.UploadedFile'> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: uint32 size = 3;
   */
  size: number;

  /**
   * @generated from field: string ref = 4;
   */
  ref: string;

  /**
   * @generated from field: string remote_path = 5;
   */
  remotePath: string;

  /**
   * @generated from field: string dropbox_key = 6;
   */
  dropboxKey: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.UploadedFile
 */
export type UploadedFileJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string id = 2;
   */
  id?: string;

  /**
   * @generated from field: uint32 size = 3;
   */
  size?: number;

  /**
   * @generated from field: string ref = 4;
   */
  ref?: string;

  /**
   * @generated from field: string remote_path = 5;
   */
  remotePath?: string;

  /**
   * @generated from field: string dropbox_key = 6;
   */
  dropboxKey?: string;
};

export type UploadedFileValid = UploadedFile;

/**
 * Describes the message vmspdb.api.proto.v1.UploadedFile.
 * Use `create(UploadedFileSchema)` to create a new message.
 */
export const UploadedFileSchema: GenMessage<
  UploadedFile,
  { jsonType: UploadedFileJson; validType: UploadedFileValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_type_common, 5);

/**
 * @generated from message vmspdb.api.proto.v1.AuditUpdater
 */
export type AuditUpdater = Message<'vmspdb.api.proto.v1.AuditUpdater'> & {
  /**
   * Useful for functions to mark a firestore item to prevent infinite loops
   *
   * @generated from field: vmspdb.api.proto.v1.AuditUpdaterType type = 1;
   */
  type: AuditUpdaterType;

  /**
   * @generated from field: string entity = 2;
   */
  entity: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.AuditUpdater
 */
export type AuditUpdaterJson = {
  /**
   * Useful for functions to mark a firestore item to prevent infinite loops
   *
   * @generated from field: vmspdb.api.proto.v1.AuditUpdaterType type = 1;
   */
  type?: AuditUpdaterTypeJson;

  /**
   * @generated from field: string entity = 2;
   */
  entity?: string;
};

export type AuditUpdaterValid = AuditUpdater;

/**
 * Describes the message vmspdb.api.proto.v1.AuditUpdater.
 * Use `create(AuditUpdaterSchema)` to create a new message.
 */
export const AuditUpdaterSchema: GenMessage<
  AuditUpdater,
  { jsonType: AuditUpdaterJson; validType: AuditUpdaterValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_type_common, 6);

/**
 * @generated from message vmspdb.api.proto.v1.DateRange
 */
export type DateRange = Message<'vmspdb.api.proto.v1.DateRange'> & {
  /**
   * @generated from field: google.protobuf.Timestamp start = 1;
   */
  start?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end = 2;
   */
  end?: Timestamp;
};

/**
 * @generated from message vmspdb.api.proto.v1.DateRange
 */
export type DateRangeJson = {
  /**
   * @generated from field: google.protobuf.Timestamp start = 1;
   */
  start?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp end = 2;
   */
  end?: TimestampJson;
};

export type DateRangeValid = DateRange;

/**
 * Describes the message vmspdb.api.proto.v1.DateRange.
 * Use `create(DateRangeSchema)` to create a new message.
 */
export const DateRangeSchema: GenMessage<
  DateRange,
  { jsonType: DateRangeJson; validType: DateRangeValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_type_common, 7);

/**
 * Represents a whole or partial calendar date, such as a birthday. The time of
 * day and time zone are either specified elsewhere or are insignificant. The
 * date is relative to the Gregorian Calendar. This can represent one of the
 * following:
 *
 * * A full date, with non-zero year, month, and day values
 * * A month and day value, with a zero year, such as an anniversary
 * * A year on its own, with zero month and day values
 * * A year and month value, with a zero day, such as a credit card expiration
 * date
 *
 * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
 * `google.protobuf.Timestamp`.
 *
 * @generated from message vmspdb.api.proto.v1.Date
 */
export type Date = Message<'vmspdb.api.proto.v1.Date'> & {
  /**
   * Year of the date. Must be from 1 to 9999, or 0 to specify a date without
   * a year.
   *
   * @generated from field: int32 year = 1;
   */
  year: number;

  /**
   * Month of a year. Must be from 1 to 12, or 0 to specify a year without a
   * month and day.
   *
   * @generated from field: int32 month = 2;
   */
  month: number;

  /**
   * Day of a month. Must be from 1 to 31 and valid for the year and month, or 0
   * to specify a year by itself or a year and month where the day isn't
   * significant.
   *
   * @generated from field: int32 day = 3;
   */
  day: number;
};

/**
 * Represents a whole or partial calendar date, such as a birthday. The time of
 * day and time zone are either specified elsewhere or are insignificant. The
 * date is relative to the Gregorian Calendar. This can represent one of the
 * following:
 *
 * * A full date, with non-zero year, month, and day values
 * * A month and day value, with a zero year, such as an anniversary
 * * A year on its own, with zero month and day values
 * * A year and month value, with a zero day, such as a credit card expiration
 * date
 *
 * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
 * `google.protobuf.Timestamp`.
 *
 * @generated from message vmspdb.api.proto.v1.Date
 */
export type DateJson = {
  /**
   * Year of the date. Must be from 1 to 9999, or 0 to specify a date without
   * a year.
   *
   * @generated from field: int32 year = 1;
   */
  year?: number;

  /**
   * Month of a year. Must be from 1 to 12, or 0 to specify a year without a
   * month and day.
   *
   * @generated from field: int32 month = 2;
   */
  month?: number;

  /**
   * Day of a month. Must be from 1 to 31 and valid for the year and month, or 0
   * to specify a year by itself or a year and month where the day isn't
   * significant.
   *
   * @generated from field: int32 day = 3;
   */
  day?: number;
};

export type DateValid = Date;

/**
 * Describes the message vmspdb.api.proto.v1.Date.
 * Use `create(DateSchema)` to create a new message.
 */
export const DateSchema: GenMessage<
  Date,
  { jsonType: DateJson; validType: DateValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_type_common, 8);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskType
 */
export type ProjectSurveyTaskType =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskType'> & {
    /**
     * @generated from oneof vmspdb.api.proto.v1.ProjectSurveyTaskType.type
     */
    type:
      | {
          /**
           * @generated from field: vmspdb.api.proto.v1.ProjectSurveyType task = 1;
           */
          value: ProjectSurveyType;
          case: 'task';
        }
      | {
          /**
           * @generated from field: vmspdb.api.proto.v1.ProjectStakingType staking = 2;
           */
          value: ProjectStakingType;
          case: 'staking';
        }
      | {
          /**
           * @generated from field: bool custom = 3;
           */
          value: boolean;
          case: 'custom';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskType
 */
export type ProjectSurveyTaskTypeJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveyType task = 1;
   */
  task?: ProjectSurveyTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectStakingType staking = 2;
   */
  staking?: ProjectStakingTypeJson;

  /**
   * @generated from field: bool custom = 3;
   */
  custom?: boolean;
};

export type ProjectSurveyTaskTypeValid = ProjectSurveyTaskType;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskType.
 * Use `create(ProjectSurveyTaskTypeSchema)` to create a new message.
 */
export const ProjectSurveyTaskTypeSchema: GenMessage<
  ProjectSurveyTaskType,
  { jsonType: ProjectSurveyTaskTypeJson; validType: ProjectSurveyTaskTypeValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_type_common, 9);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskTypeWithDescription
 */
export type ProjectSurveyTaskTypeWithDescription =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskTypeWithDescription'> & {
    /**
     * @generated from oneof vmspdb.api.proto.v1.ProjectSurveyTaskTypeWithDescription.type
     */
    type:
      | {
          /**
           * @generated from field: vmspdb.api.proto.v1.ProjectSurveyType task = 1;
           */
          value: ProjectSurveyType;
          case: 'task';
        }
      | {
          /**
           * @generated from field: vmspdb.api.proto.v1.ProjectStakingType staking = 2;
           */
          value: ProjectStakingType;
          case: 'staking';
        }
      | {
          /**
           * @generated from field: bool custom = 3;
           */
          value: boolean;
          case: 'custom';
        }
      | { case: undefined; value?: undefined };

    /**
     * @generated from field: string custom_text = 4;
     */
    customText: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskTypeWithDescription
 */
export type ProjectSurveyTaskTypeWithDescriptionJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveyType task = 1;
   */
  task?: ProjectSurveyTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectStakingType staking = 2;
   */
  staking?: ProjectStakingTypeJson;

  /**
   * @generated from field: bool custom = 3;
   */
  custom?: boolean;

  /**
   * @generated from field: string custom_text = 4;
   */
  customText?: string;
};

export type ProjectSurveyTaskTypeWithDescriptionValid =
  ProjectSurveyTaskTypeWithDescription;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskTypeWithDescription.
 * Use `create(ProjectSurveyTaskTypeWithDescriptionSchema)` to create a new message.
 */
export const ProjectSurveyTaskTypeWithDescriptionSchema: GenMessage<
  ProjectSurveyTaskTypeWithDescription,
  {
    jsonType: ProjectSurveyTaskTypeWithDescriptionJson;
    validType: ProjectSurveyTaskTypeWithDescriptionValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_type_common, 10);

/**
 * @generated from enum vmspdb.api.proto.v1.ExternalType
 */
export enum ExternalType {
  /**
   * @generated from enum value: EXTERNAL_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EXTERNAL_TYPE_FIREBASE_IDENTITY = 1;
   */
  FIREBASE_IDENTITY = 1,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ExternalType
 */
export type ExternalTypeJson =
  'EXTERNAL_TYPE_UNSPECIFIED' | 'EXTERNAL_TYPE_FIREBASE_IDENTITY';

/**
 * Describes the enum vmspdb.api.proto.v1.ExternalType.
 */
export const ExternalTypeSchema: GenEnum<ExternalType, ExternalTypeJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_type_common, 0);

/**
 * @generated from enum vmspdb.api.proto.v1.CURRENCY
 */
export enum CURRENCY {
  /**
   * @generated from enum value: CURRENCY_UNSPECIFIED = 0;
   */
  CURRENCY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: CURRENCY_USD = 1;
   */
  CURRENCY_USD = 1,
}

/**
 * @generated from enum vmspdb.api.proto.v1.CURRENCY
 */
export type CURRENCYJson = 'CURRENCY_UNSPECIFIED' | 'CURRENCY_USD';

/**
 * Describes the enum vmspdb.api.proto.v1.CURRENCY.
 */
export const CURRENCYSchema: GenEnum<CURRENCY, CURRENCYJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_type_common, 1);

/**
 * @generated from enum vmspdb.api.proto.v1.UserRole
 */
export enum UserRole {
  /**
   * @generated from enum value: USER_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_ROLE_CLIENT = 10;
   */
  CLIENT = 10,

  /**
   * @generated from enum value: USER_ROLE_FIELD_EMPLOYEE = 20;
   */
  FIELD_EMPLOYEE = 20,

  /**
   * @generated from enum value: USER_ROLE_OFFICE_EMPLOYEE = 21;
   */
  OFFICE_EMPLOYEE = 21,

  /**
   * @generated from enum value: USER_ROLE_MANAGEMENT = 30;
   */
  MANAGEMENT = 30,

  /**
   * @generated from enum value: USER_ROLE_OWNER = 99;
   */
  OWNER = 99,

  /**
   * @generated from enum value: USER_ROLE_SYSOP = 100;
   */
  SYSOP = 100,
}

/**
 * @generated from enum vmspdb.api.proto.v1.UserRole
 */
export type UserRoleJson =
  | 'USER_ROLE_UNSPECIFIED'
  | 'USER_ROLE_CLIENT'
  | 'USER_ROLE_FIELD_EMPLOYEE'
  | 'USER_ROLE_OFFICE_EMPLOYEE'
  | 'USER_ROLE_MANAGEMENT'
  | 'USER_ROLE_OWNER'
  | 'USER_ROLE_SYSOP';

/**
 * Describes the enum vmspdb.api.proto.v1.UserRole.
 */
export const UserRoleSchema: GenEnum<UserRole, UserRoleJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_type_common, 2);

/**
 * @generated from enum vmspdb.api.proto.v1.SortDirection
 */
export enum SortDirection {
  /**
   * @generated from enum value: SORT_DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SORT_DIRECTION_ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: SORT_DIRECTION_DESC = 2;
   */
  DESC = 2,
}

/**
 * @generated from enum vmspdb.api.proto.v1.SortDirection
 */
export type SortDirectionJson =
  'SORT_DIRECTION_UNSPECIFIED' | 'SORT_DIRECTION_ASC' | 'SORT_DIRECTION_DESC';

/**
 * Describes the enum vmspdb.api.proto.v1.SortDirection.
 */
export const SortDirectionSchema: GenEnum<SortDirection, SortDirectionJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_type_common, 3);

/**
 * @generated from enum vmspdb.api.proto.v1.AuditUpdaterType
 */
export enum AuditUpdaterType {
  /**
   * @generated from enum value: AUDIT_UPDATER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AUDIT_UPDATER_TYPE_FRONTEND = 1;
   */
  FRONTEND = 1,

  /**
   * @generated from enum value: AUDIT_UPDATER_TYPE_API = 2;
   */
  API = 2,

  /**
   * @generated from enum value: AUDIT_UPDATER_TYPE_FUNCTIONS = 3;
   */
  FUNCTIONS = 3,

  /**
   * @generated from enum value: AUDIT_UPDATER_TYPE_SYSTEM = 4;
   */
  SYSTEM = 4,
}

/**
 * @generated from enum vmspdb.api.proto.v1.AuditUpdaterType
 */
export type AuditUpdaterTypeJson =
  | 'AUDIT_UPDATER_TYPE_UNSPECIFIED'
  | 'AUDIT_UPDATER_TYPE_FRONTEND'
  | 'AUDIT_UPDATER_TYPE_API'
  | 'AUDIT_UPDATER_TYPE_FUNCTIONS'
  | 'AUDIT_UPDATER_TYPE_SYSTEM';

/**
 * Describes the enum vmspdb.api.proto.v1.AuditUpdaterType.
 */
export const AuditUpdaterTypeSchema: GenEnum<
  AuditUpdaterType,
  AuditUpdaterTypeJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_type_common, 4);

/**
 * / Shared
 *
 * @generated from enum vmspdb.api.proto.v1.ProjectJobType
 * @deprecated
 */
export enum ProjectJobType {
  /**
   * @generated from enum value: PROJECT_JOB_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_PLOT_PLAN = 1;
   */
  PLOT_PLAN = 1,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_SITE_PLAN = 2;
   */
  SITE_PLAN = 2,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_MAJOR_SUBDIVISION = 3;
   */
  MAJOR_SUBDIVISION = 3,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_BOUNDARY_SURVEY = 4;
   */
  BOUNDARY_SURVEY = 4,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_REZONING = 5;
   */
  REZONING = 5,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_FUTURE_LAND_USE_MAP_AMENDMENT = 6;
   */
  FUTURE_LAND_USE_MAP_AMENDMENT = 6,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_PLAT_REVISION = 7;
   */
  PLAT_REVISION = 7,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_RECORD_PLAT = 8;
   */
  RECORD_PLAT = 8,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_ALTA_SURVEY = 9;
   */
  ALTA_SURVEY = 9,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_EXISTING_CONDITIONS_SURVEY = 10;
   */
  EXISTING_CONDITIONS_SURVEY = 10,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_LEGAL_DESCRIPTION = 11;
   */
  LEGAL_DESCRIPTION = 11,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_VARIANCE = 12;
   */
  VARIANCE = 12,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_CONCEPT = 13;
   */
  CONCEPT = 13,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_PROPOSAL = 14;
   */
  PROPOSAL = 14,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_MINOR_SUBDIVISION = 15;
   */
  MINOR_SUBDIVISION = 15,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_DRAINAGE_PLAN = 16;
   */
  DRAINAGE_PLAN = 16,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_EASEMENT_EXHIBIT = 17;
   */
  EASEMENT_EXHIBIT = 17,

  /**
   * @generated from enum value: PROJECT_JOB_TYPE_STREET_PLAN = 18;
   */
  STREET_PLAN = 18,
}

/**
 * / Shared
 *
 * @generated from enum vmspdb.api.proto.v1.ProjectJobType
 * @deprecated
 */
export type ProjectJobTypeJson =
  | 'PROJECT_JOB_TYPE_UNSPECIFIED'
  | 'PROJECT_JOB_TYPE_PLOT_PLAN'
  | 'PROJECT_JOB_TYPE_SITE_PLAN'
  | 'PROJECT_JOB_TYPE_MAJOR_SUBDIVISION'
  | 'PROJECT_JOB_TYPE_BOUNDARY_SURVEY'
  | 'PROJECT_JOB_TYPE_REZONING'
  | 'PROJECT_JOB_TYPE_FUTURE_LAND_USE_MAP_AMENDMENT'
  | 'PROJECT_JOB_TYPE_PLAT_REVISION'
  | 'PROJECT_JOB_TYPE_RECORD_PLAT'
  | 'PROJECT_JOB_TYPE_ALTA_SURVEY'
  | 'PROJECT_JOB_TYPE_EXISTING_CONDITIONS_SURVEY'
  | 'PROJECT_JOB_TYPE_LEGAL_DESCRIPTION'
  | 'PROJECT_JOB_TYPE_VARIANCE'
  | 'PROJECT_JOB_TYPE_CONCEPT'
  | 'PROJECT_JOB_TYPE_PROPOSAL'
  | 'PROJECT_JOB_TYPE_MINOR_SUBDIVISION'
  | 'PROJECT_JOB_TYPE_DRAINAGE_PLAN'
  | 'PROJECT_JOB_TYPE_EASEMENT_EXHIBIT'
  | 'PROJECT_JOB_TYPE_STREET_PLAN';

/**
 * Describes the enum vmspdb.api.proto.v1.ProjectJobType.
 * @deprecated
 */
export const ProjectJobTypeSchema: GenEnum<ProjectJobType, ProjectJobTypeJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_type_common, 5);

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectSurveyType
 */
export enum ProjectSurveyType {
  /**
   * @generated from enum value: PROJECT_SURVEY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_SURVEY_TYPE_TOPO_FOR_PLOT_PLAN = 1;
   */
  TOPO_FOR_PLOT_PLAN = 1,

  /**
   * @generated from enum value: PROJECT_SURVEY_TYPE_TOPO_FOR_SITE_PLAN = 2;
   */
  TOPO_FOR_SITE_PLAN = 2,

  /**
   * @generated from enum value: PROJECT_SURVEY_TYPE_TOPO_FOR_MASD = 4;
   */
  TOPO_FOR_MASD = 4,

  /**
   * @generated from enum value: PROJECT_SURVEY_TYPE_BOUNDARY_SURVEY = 3;
   */
  BOUNDARY_SURVEY = 3,

  /**
   * @generated from enum value: PROJECT_SURVEY_TYPE_ASBUILT = 5;
   */
  ASBUILT = 5,

  /**
   * @generated from enum value: PROJECT_SURVEY_TYPE_SET_PINS = 6;
   */
  SET_PINS = 6,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectSurveyType
 */
export type ProjectSurveyTypeJson =
  | 'PROJECT_SURVEY_TYPE_UNSPECIFIED'
  | 'PROJECT_SURVEY_TYPE_TOPO_FOR_PLOT_PLAN'
  | 'PROJECT_SURVEY_TYPE_TOPO_FOR_SITE_PLAN'
  | 'PROJECT_SURVEY_TYPE_TOPO_FOR_MASD'
  | 'PROJECT_SURVEY_TYPE_BOUNDARY_SURVEY'
  | 'PROJECT_SURVEY_TYPE_ASBUILT'
  | 'PROJECT_SURVEY_TYPE_SET_PINS';

/**
 * Describes the enum vmspdb.api.proto.v1.ProjectSurveyType.
 */
export const ProjectSurveyTypeSchema: GenEnum<
  ProjectSurveyType,
  ProjectSurveyTypeJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_type_common, 6);

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectStakingType
 */
export enum ProjectStakingType {
  /**
   * @generated from enum value: PROJECT_STAKING_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_STAKING_TYPE_STAKING_FOR_PUSH_OUT = 1;
   */
  STAKING_FOR_PUSH_OUT = 1,

  /**
   * @generated from enum value: PROJECT_STAKING_TYPE_STAKING_FOR_FOOTINGS = 2;
   */
  STAKING_FOR_FOOTINGS = 2,

  /**
   * @generated from enum value: PROJECT_STAKING_TYPE_STAKING_FOR_BLOCK = 3;
   */
  STAKING_FOR_BLOCK = 3,

  /**
   * @generated from enum value: PROJECT_STAKING_TYPE_STAKING_FOR_BASEMENT_DIG_OUT = 4;
   */
  STAKING_FOR_BASEMENT_DIG_OUT = 4,

  /**
   * @generated from enum value: PROJECT_STAKING_TYPE_STAKING_FOR_BASEMENT_FOOTING = 5;
   */
  STAKING_FOR_BASEMENT_FOOTING = 5,

  /**
   * @generated from enum value: PROJECT_STAKING_TYPE_STAKING_FOR_BASEMENT_WALLS = 6;
   */
  STAKING_FOR_BASEMENT_WALLS = 6,

  /**
   * @generated from enum value: PROJECT_STAKING_TYPE_CONSTRUCTION_STAKING = 7;
   */
  CONSTRUCTION_STAKING = 7,

  /**
   * @generated from enum value: PROJECT_STAKING_TYPE_STAKING_FOR_PUSH_OUT_WITH_10_FT_OFFSETS = 8;
   */
  STAKING_FOR_PUSH_OUT_WITH_10_FT_OFFSETS = 8,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectStakingType
 */
export type ProjectStakingTypeJson =
  | 'PROJECT_STAKING_TYPE_UNSPECIFIED'
  | 'PROJECT_STAKING_TYPE_STAKING_FOR_PUSH_OUT'
  | 'PROJECT_STAKING_TYPE_STAKING_FOR_FOOTINGS'
  | 'PROJECT_STAKING_TYPE_STAKING_FOR_BLOCK'
  | 'PROJECT_STAKING_TYPE_STAKING_FOR_BASEMENT_DIG_OUT'
  | 'PROJECT_STAKING_TYPE_STAKING_FOR_BASEMENT_FOOTING'
  | 'PROJECT_STAKING_TYPE_STAKING_FOR_BASEMENT_WALLS'
  | 'PROJECT_STAKING_TYPE_CONSTRUCTION_STAKING'
  | 'PROJECT_STAKING_TYPE_STAKING_FOR_PUSH_OUT_WITH_10_FT_OFFSETS';

/**
 * Describes the enum vmspdb.api.proto.v1.ProjectStakingType.
 */
export const ProjectStakingTypeSchema: GenEnum<
  ProjectStakingType,
  ProjectStakingTypeJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_type_common, 7);
